import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { CampaignProvider } from "./components/Logic/CampaignContext";
import NavBar from "./components/Logic/NavBar";

import MainScreen from "./components/Logic/MainScreen";
import LoadCampaign from "./components/Logic/LoadCampaign";
import CampaignDashboard from "./components/Logic/CampaignDashboard";
import CampaignSetup from "./components/CampaignSetup/CampaignSetup";

import SettlementSheet from "./components/SettlementSheet/SettlementSheet";
import DepartingSurvivors from "./components/Logic/DepartingSurvivors";
import TimelinePage from "./components/Logic/TimelinePage";

import Search from "./components/Compendium/Search";

import AuthGate from "./components/Logic/AuthGate";

function App() {
  return (
    <AuthGate><CampaignProvider>
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<MainScreen />} />
          <Route path="/load" element={<LoadCampaign />} />
          <Route path="/dashboard" element={<CampaignDashboard />} />
          <Route path="/setup" element={<CampaignSetup />} />

          <Route path="/settlement" element={<SettlementSheet />} />
          <Route path="/departing" element={<DepartingSurvivors />} />
          <Route path="/timeline" element={<TimelinePage />} />
          <Route path="/compendium" element={<Search />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </CampaignProvider></AuthGate>
  );
}

export default App;
